import React, { useEffect, useState } from "react";
import { getAllYhteyshenkilot } from "../../api/api";
import { sendReportEmail } from "../hooks/emailService";
import { getEmailInlineImages } from "./emailAssets";
import useSharePoint from "../hooks/useSharepoint";
import '../../App.css';
export default function EmailModal({
  open,
  onClose,
  initialRecipients = [],
  subject,
  body,
  pdfBase64,
  filename,
  card
}) {
  const [recipients, setRecipients] = useState([]);
  const [recipientInput, setRecipientInput] = useState("");
  const [contactOptions, setContactOptions] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailBody, setEmailBody] = useState("");
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [sentTo, setSentTo] = useState("");
  const {
  files,
  loadingSP,
  spFolder,
  currentFolderId,
  setCurrentFolderId,
  folderStack,
  setFolderStack
} = useSharePoint(card);

const [selectedSharePointFiles, setSelectedSharePointFiles] = useState([]);

const addSharePointAttachment = (file) => {
  setSelectedSharePointFiles((prev) =>
    prev.some((item) => item.id === file.id)
      ? prev
      : [...prev, file]
  );
};

const removeSharePointAttachment = (fileId) => {
  setSelectedSharePointFiles((prev) =>
    prev.filter((file) => file.id !== fileId)
  );
};
  const escapeHtml = (text) =>
    text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");

  const plainTextToHtml = (text) =>
    escapeHtml(text).replace(/\n/g, "<br>");

  const makeLinksClickable = (html) => {
    return html
      .replace(
        /(https?:\/\/[^\s<]+|www\.[^\s<]+)/g,
        (url) => {
          const href = url.startsWith("http")
            ? url
            : `https://${url}`;

          return `<a href="${href}">${url}</a>`;
        }
      )
      .replace(
        /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
        `<a href="mailto:$1">$1</a>`
      )
      .replace(
        /(\+?\d[\d\s-]{6,}\d)/g,
        (phone) => {
          const clean = phone.replace(/\s|-/g, "");

          return `<a href="tel:${clean}">${phone}</a>`;
        }
      );
  };
  useEffect(() => {
    if (!open) return;

    setRecipients(initialRecipients);
    setEmailSubject(subject || "");
    setEmailBody(body || "");
    setSent(false);
    setSentTo("");
    setRecipientInput("");

    getAllYhteyshenkilot()
      .then((res) => setContactOptions(res.data || []))
      .catch((err) => console.error("Failed to load contacts:", err));
  }, [open, initialRecipients, subject, body]);

  if (!open) return null;

  const addRecipient = (email) => {
    const clean = email.trim();
    if (!clean) return;

    setRecipients((prev) =>
      prev.includes(clean) ? prev : [...prev, clean]
    );

    setRecipientInput("");
    setShowDropdown(false);
  };

  const removeRecipient = (email) => {
    setRecipients((prev) => prev.filter((item) => item !== email));
  };

  const filteredContacts = contactOptions.filter((contact) => {
    const search = recipientInput.toLowerCase();
    const fullName = `${contact.etunimi || ""} ${contact.sukunimi || ""}`.toLowerCase();
    const email = (contact.sposti || "").toLowerCase();
    const company = (contact.yritys || "").toLowerCase();

    return (
      recipientInput &&
      contact.sposti &&
      (fullName.includes(search) ||
        email.includes(search) ||
        company.includes(search))
    );
  });

  const handleSend = async () => {
    try {
      setSending(true);

const htmlBody = `
<p>${makeLinksClickable(plainTextToHtml(emailBody))}</p>
`;

await sendReportEmail({
  to: recipients.join(";"),
  subject: emailSubject,
  body: htmlBody,
  fileBase64: pdfBase64,
  filename,
  sharePointAttachments: selectedSharePointFiles.map((file) => ({
    id: file.id,
    name: file.name,
    contentType: file.file?.mimeType || "application/octet-stream",
    downloadUrl: file["@microsoft.graph.downloadUrl"],
    driveId: file.parentReference?.driveId
  }))
});

      setSentTo(recipients.join(", "));
      setSent(true);
    } catch (err) {
      console.error(err);
      alert("❌ Lähetys epäonnistui");
    } finally {
      setSending(false);
    }
  };

return (
  <div className="outlook-modal-overlay">
    <div className="outlook-modal">
      {sending ? (
        <div className="email-overlay-state">
          <div className="spinner-border text-primary mb-3" />
          <h5>Lähetetään sähköpostia...</h5>
          <div className="text-muted">{recipients.join(", ")}</div>
        </div>
      ) : sent ? (
        <div className="email-overlay-state">
          <div className="success-check">✓</div>
          <h4>Lähetetty!</h4>
          <div className="text-muted">{sentTo}</div>

          <button className="btn btn-success mt-4" onClick={onClose}>
            Sulje
          </button>
        </div>
      ) : (
        <>
          <div className="outlook-header">
            <span>Uusi viesti</span>
            <button onClick={onClose}>✕</button>
          </div>

          <div className="email-layout">
            <div className="email-compose-area">
              <div className="outlook-fields">
                <div className="recipient-row recipient-row-multi">
                  <span className="recipient-label">Vastaanottaja</span>

                  <div className="recipient-box">
                    {recipients.map((email) => (
                      <div className="recipient-chip" key={email}>
                        <i className="bi bi-person-circle"></i>
                        <span>{email}</span>
                        <button type="button" onClick={() => removeRecipient(email)}>
                          ×
                        </button>
                      </div>
                    ))}

                    <input
                      className="recipient-inline-input"
                      value={recipientInput}
                      placeholder="Kirjoita nimi tai sähköposti"
                      onFocus={() => setShowDropdown(true)}
                      onChange={(e) => {
                        setRecipientInput(e.target.value);
                        setShowDropdown(true);
                      }}
                      onKeyDown={(e) => {
                        if (["Enter", ",", "Tab"].includes(e.key)) {
                          e.preventDefault();
                          addRecipient(recipientInput.replace(",", ""));
                        }
                      }}
                    />

                    {showDropdown && filteredContacts.length > 0 && (
                      <div className="recipient-dropdown">
                        {filteredContacts.map((contact) => (
                          <button
                            key={contact.id_yhteyshenkilo || contact.id}
                            type="button"
                            className="recipient-option"
                            onMouseDown={(e) => {
                              e.preventDefault();
                              addRecipient(contact.sposti);
                            }}
                          >
                            <div className="recipient-option-name">
                              {contact.etunimi} {contact.sukunimi}
                              {contact.yritys ? `, ${contact.yritys}` : ""}
                            </div>
                            <div className="recipient-option-email">
                              {contact.sposti}
                            </div>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <input
                  className="outlook-input"
                  placeholder="Aihe"
                  value={emailSubject}
                  onChange={(e) => setEmailSubject(e.target.value)}
                />
              </div>

              <textarea
                className="outlook-body"
                value={emailBody}
                onChange={(e) => setEmailBody(e.target.value)}
              />

              {filename && (
                <div className="email-attachment-preview">
                  <i className="bi bi-paperclip"></i>
                  <span>{filename}</span>
                </div>
              )}

              {selectedSharePointFiles.map((file) => (
                <div key={file.id} className="email-attachment-preview">
                  <i className="bi bi-paperclip"></i>
                  <span>{file.name}</span>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger ms-auto"
                    onClick={() => removeSharePointAttachment(file.id)}
                  >
                    ×
                  </button>
                </div>
              ))}

              <div className="outlook-footer">
                <button
                  className="btn-send"
                  onClick={handleSend}
                  disabled={!recipients.length}
                >
                  Lähetä
                </button>

                <button className="btn-secondary" onClick={onClose}>
                  Peruuta
                </button>
              </div>
            </div>

            <div className="email-attachment-drawer">
              <div className="fw-bold mb-2">SharePoint-liitteet</div>

              {folderStack.length > 0 && (
                <button
                  className="btn btn-sm btn-outline-secondary mb-2"
                  onClick={() => {
                    setFolderStack((prev) => {
                      const newStack = [...prev];
                      const last = newStack.pop();
                      setCurrentFolderId(last || null);
                      return newStack;
                    });
                  }}
                >
                  ⬅️ Takaisin
                </button>
              )}

              {loadingSP ? (
  <div className="text-muted small">Ladataan...</div>
) : !spFolder ? (
  <div className="text-muted small">
    Ei SharePoint-kansiota
  </div>
) : files.length === 0 ? (
  <div className="text-muted small">
    Ei tiedostoja
  </div>
) : (
<div className="sharepoint-modal-list">
  {files.map((file) => (
    <div
      key={file.id}
      className="sharepoint-modal-card"
    >
      <div
        className="sharepoint-modal-file"
        onClick={() => {
          if (file.folder) {
            setFolderStack((prev) => [
              ...prev,
              currentFolderId || spFolder?.id
            ]);
            setCurrentFolderId(file.id);
          } else {
            window.open(file.webUrl, "_blank");
          }
        }}
      >
        <div className="sharepoint-modal-file-info">
          <div className="sharepoint-modal-icon">
            {file.folder ? "📁" : "📄"}
          </div>

          <div>
            <div className="sharepoint-modal-name">
              {file.name}
            </div>

            <div className="sharepoint-modal-meta">
              {file.folder
                ? "Kansio"
                : file.size
                ? `${Math.round(file.size / 1024)} KB`
                : "Tiedosto"}
            </div>
          </div>
        </div>

        {!file.folder && (
          <button
            type="button"
            className="btn btn-success btn-sm"
            onClick={(e) => {
              e.stopPropagation();
              addSharePointAttachment(file);
            }}
          >
            +
          </button>
        )}
      </div>
    </div>
  ))}
</div>
)}
            </div>
          </div>
        </>
      )}
    </div>
  </div>
);
}